import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/models';;
import type { ListWhatsAppSenderConfigurationMasterResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError, Observable } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class SmsSenderConfigService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  CreateSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, payload:any): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_COMPANY_SMS_SENDER_CONFIG;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_FRANCHISE_SMS_SENDER_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, configId:number, payload:any): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_COMPANY_SMS_SENDER_CONFIG;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_FRANCHISE_SMS_SENDER_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.put(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  ListSmsSenderConfigByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_COMPANY_SMS_SENDER_CONFIG;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_FRANCHISE_SMS_SENDER_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ActiveSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, configId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_COMPANY_SMS_SENDER_ACTIVE
          .replace('{config_id}', configId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_FRANCHISE_SMS_SENDER_ACTIVE
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{config_id}', configId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_SMS_SENDER_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{config_id}', configId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_SMS_SENDER_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{config_id}', configId.toString());
        break;
    }
    return this.http.post(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  InActiveSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, configId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_COMPANY_SMS_SENDER_INACTIVE
          .replace('{config_id}', configId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_FRANCHISE_SMS_SENDER_INACTIVE
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{config_id}', configId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_SMS_SENDER_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{config_id}', configId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_SMS_SENDER_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{config_id}', configId.toString());
        break;
    }
    return this.http.post(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
  
}
